<template>
  <LayoutContainer
    :props="props"
    @handleClick="openIm"
  >
    <img
      class="kaer-customer-img"
      :src="props.src"
      v-if="props.src"
      :style="{ borderRadius: px2rem(props.borderRadius) }"
    >
    <div
      class="kaer-customer-common"
      :style="{ borderRadius: px2rem(props.borderRadius) }"
      v-else
    >
      <span>联系客服</span>
    </div>
  </LayoutContainer>
</template>

<script>
import { fetchCustomerConfig } from '@/api';
import LayoutContainer from '@/components/layout-container';
import { px2rem } from '@/utils/utils';

export default {
  name: 'kaer-customer-im',
  components: {
    LayoutContainer
  },
  props: {
    props: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      px2rem
    };
  },
  methods: {
    async openIm() {
      const { uid } = await fetchCustomerConfig();
      const adapt = window.__kaer_adapt__;
      adapt.goIM({ toId: uid, customerTypeId: 1 });
    }
  }
};
</script>

<style scoped lang="less">
.kaer-customer-img,
.kaer-customer-common {
  width: 100%;
  height: 100%;
}

.kaer-customer-common {
  position: relative;
  background-color: #409EFF;
  color: #fff;
  text-align: center;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
